module.exports = ".hide{\n    display:none;  \n  }\n  .language-selctr {\n    color:black;\n    width: 120px !important;\n   \n}\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.css
// module id = ./src/app/app.component.css
// module chunks = main